<template>
  <div class="chart-wrap" ref="chart"></div>
</template>

<script>
import $ from 'jquery'
import _ from 'lodash'
import echarts from 'echarts'

export default {
  props: {
    option: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    option (val) {
      this.refresh()
    }
  },
  data () {
    return {
      chart: null,
      defaultOption: {

      }
    }
  },
  computed: {
    customizedOption () {
      return {
        ...this.defaultOption,
        ...this.option
      }
    }
  },
  mounted () {
    this.init()
    this.setResize()
  },
  methods: {
    init () {
      this.chart = echarts.init(this.$refs.chart)
      this.chart.setOption(this.customizedOption)
    },
    setResize () {
      $(window).on('resize.chart', _.debounce(() => {
        if (!this.chart) return
        this.chart.resize()
      }, 500))
    },
    refresh () {
      this.chart.clear()
      this.chart.setOption(this.customizedOption)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .chart-wrap
    width 100%
    height 100%
</style>
